import { get, post } from "@/api";

export interface ProductGoods {
  id?: number | string;
  title?: string;
  code?: string;
  barcode?: string;
  m_pic?: string;
  category_id?: number | string;
  /** 物资详情 HTML */
  html?: string | null;
  /** 规格信息 JSON（label/value） */
  information?: string | null;
  keywords?: string | null;
  views?: number | string;
  like?: number | string;
  albums?: Array<{ id?: number | string; goods_id?: number | string; url?: string }>;
  [key: string]: unknown;
}

export interface ProductSupplier {
  id?: number | string;
  name?: string;
  [key: string]: unknown;
}

/** 接口返回的规格物资（含 goods / supplier） */
export interface ProductSpecItem {
  id: number | string;
  goods_id?: number | string;
  category_id?: number | string;
  name?: string;
  price?: number | string;
  unit?: string;
  stock?: number;
  pic?: string | null;
  goods?: ProductGoods | null;
  supplier?: ProductSupplier | null;
  [key: string]: unknown;
}

export interface ProductPagesParams {
  page?: number;
  pagenumber?: number;
  search?: string;
  category_id?: number | string;
  supplier_ids?: Array<number | string>;
  sortBy?: "default" | "new" | "price_asc" | "price_desc";
}

export interface ProductPagesResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: ProductSpecItem[];
  total?: number;
  page?: number;
  pagenumber?: number;
}

/** 物资分页列表 */
export function getProductPages(params: ProductPagesParams = {}) {
  return post<ProductPagesResponse>("/platform/product/pages", params);
}

/** 企业物资规格选项 */
export interface ProductSpecOption {
  id: number | string;
  goods_id?: number | string;
  name?: string;
  sku?: string;
  price?: number | string;
  unit?: string;
  factory?: string;
  stock?: number;
  pic?: string | null;
  supplier?: ProductSupplier | null;
  [key: string]: unknown;
}

/** 企业物资（含 specs） */
export interface ProductWithSpecs {
  id: number | string;
  goods_id?: number | string;
  goods?: ProductGoods | null;
  specs?: ProductSpecOption[];
  [key: string]: unknown;
}

export interface ProductSpecsParams {
  search?: string;
  goods_id?: number | string;
}

export interface ProductSpecsResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: ProductWithSpecs[];
}

/** 物资与规格联动列表 */
export function getProductSpecs(params: ProductSpecsParams = {}) {
  return post<ProductSpecsResponse>("/platform/product/specs", params);
}

export interface ProductDetailResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: ProductWithSpecs | null;
}

/** 物资详情（企业物资 + goods + specs） */
export function getProductDetail(id: number | string) {
  return get<ProductDetailResponse>(`/platform/product/detail/${id}`);
}

/** 按编码批量匹配结果项 */
export interface ProductCodeMatchItem {
  code: string;
  id: number | string;
  goods_id?: number | string;
  name?: string;
  sku?: string;
  price?: number | string;
  unit?: string;
  pic?: string | null;
  goods?: ProductGoods | null;
  supplier?: ProductSupplier | null;
}

export interface ProductMatchCodesResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: {
    matched?: ProductCodeMatchItem[];
    missed?: string[];
  };
  errors?: Record<string, string[]>;
}

/** 按物资编码批量精确匹配规格 */
export function matchProductCodes(codes: string[]) {
  return post<ProductMatchCodesResponse>("/platform/product/match-codes", { codes });
}
